module.exports = __webpack_public_path__ + "img/paid.14b03f36.png";